export const getBackendBaseURL = () => {
    if (process.env.REACT_APP_API_URL) {
        return process.env.REACT_APP_API_URL.replace(/\/api(\/v\d+)?\/?$/, '');
    }
    return 'http://localhost:9050';
};

export const formatImgUrl = (url) => {
    if (!url) return '';
    const base = getBackendBaseURL();

    let clean = String(url).trim();
    clean = clean.replace(/\/uploads\/+\/uploads\//g, '/uploads/');

    // FIX: If the backend returned a full URL with legacy domain or port,
    // strip the domain entirely and prepend the correct dynamic `base`.
    if (clean.includes('/uploads/')) {
        const parts = clean.split('/uploads/');
        clean = '/uploads/' + parts.pop();
    }

    if (base && clean.includes('somstay.ddns.net')) {
        return clean.replace('https://somstay.ddns.net', base).replace('http://somstay.ddns.net', base);
    }

    if (clean.startsWith('http://') || clean.startsWith('https://') || clean.startsWith('data:')) {
        return clean;
    }

    return clean.startsWith('/') ? `${base}${clean}` : `${base}/${clean}`;
};
